import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { ModalController } from '@ionic/angular';
import { ForSaleCoupon, IndefiniteCoupon, Shop } from 'src/app/models/interfaces';
import { AssetlinksService } from 'src/app/services/assetlinks.service';
import { CouponListingViewerComponent } from '../../coupon-viewer/coupon-listing-viewer.component';

@Component({
  selector: 'app-coupon-lane-card',
  templateUrl: './coupon-lane-card.component.html',
  styleUrls: ['./coupon-lane-card.component.scss'],
})
export class CouponLaneCardComponent implements OnInit {
  @Input() coupon:ForSaleCoupon|IndefiniteCoupon
  @Input() shop: Shop
  @Input() cardHeight = '50vh'
  @Output() onCouponSelectEmit: EventEmitter<ForSaleCoupon|IndefiniteCoupon> = new EventEmitter();
  @Output() onWantsToFlip: EventEmitter<any> = new EventEmitter();
  linkClickThinking=false
  isButtonLoading
  searchLocation
  showDescription:boolean = false
  constructor(
    private modalCtrl:ModalController,
    public assetLinksService: AssetlinksService,
  ) {

  }

  ngOnInit() {

  }

  async toggleShowDescription(){
   this.showDescription = !this.showDescription
  }

  async viewCoupon(){
    try {
      const modal = await this.modalCtrl.create({
        component: CouponListingViewerComponent,
        initialBreakpoint: 1,
        breakpoints: [0,1],
        handle:false,
        mode:'ios',
        componentProps:{
          shop:this.shop,
          coupons:[this.coupon]
        }
      });
      await modal.present();
    } catch (error) {
      console.log(error);
    }
  }

  

  async openLink(couponListing:ForSaleCoupon) {
    if(!couponListing.productUrl){
      return
    }
    try {
      this.linkClickThinking = true
      this.linkClickThinking = false;
      Browser.open({
        url:couponListing.productUrl
      })
    } catch (error) {
      this.linkClickThinking = false
      console.log(error);
    }
  }

  flip() {
    this.onWantsToFlip.emit()
  }

  async actionButtonClick() {
    this.onCouponSelectEmit.emit(this.coupon)
        console.log('emitted from cardcomponent', this.coupon);
  }


}
